import { useId } from "react";
import { useT } from "../../../i18n";

/**
 * 무대 고르기(2026-10-08 — 무대 꾸밈 · 무대 목표 탭 공용) — 위쪽에서 제품(스마트브릭 기구 무대 · 마이크로비트 놀이터)을 먼저 고르고,
 * 선택 상자에서 무대(차시 · 장면) 하나를 고른다. 선택지 글에 지금 상태(기본 · 꾸밈 vN · 초안)를 붙인다.
 */
export type StageProduct = "sb" | "mb";

export interface StagePickOption {
  readonly key: string;
  readonly label: string;
  /** 상태 글(기본 · 꾸밈 v2 · 초안 v3) */
  readonly state?: string;
}

export function StagePicker({
  product,
  onProduct,
  options,
  value,
  onPick,
  testId,
}: {
  product: StageProduct;
  onProduct: (p: StageProduct) => void;
  options: readonly StagePickOption[] | null;
  value: string | null;
  onPick: (key: string) => void;
  testId: string;
}) {
  const t = useT();
  const id = useId();
  return (
    <section className="pf-pane pf-ops-picker" aria-label={t("ops.picker.title")}>
      <div className="pf-seg pf-seg--pill" role="tablist" data-testid={`${testId}-product`}>
        {(["sb", "mb"] as const).map((p) => (
          <button
            key={p}
            type="button"
            role="tab"
            aria-selected={p === product}
            className={`pf-ops-type${p === product ? " pf-ops-type--on" : ""}`}
            onClick={() => p !== product && onProduct(p)}
          >
            {t(`ops.picker.product.${p}`)}
          </button>
        ))}
      </div>
      <label className="pf-ops-picker__pick" htmlFor={`${id}-s`}>
        <span>{t(product === "sb" ? "ops.picker.stage" : "ops.picker.scene")}</span>
        <select
          id={`${id}-s`}
          value={value ?? ""}
          disabled={!options}
          data-testid={testId}
          onChange={(e) => e.target.value && onPick(e.target.value)}
        >
          <option value="">{options ? t("ops.picker.choose") : t("common.loading")}</option>
          {(options ?? []).map((o) => (
            <option key={o.key} value={o.key}>
              {o.label}
              {o.state ? ` — ${o.state}` : ""}
            </option>
          ))}
        </select>
      </label>
    </section>
  );
}
